// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"812":"1e13879a","903":"20865647"}[chunkId] + ".chunk.js";
};